import React from "react";

import { Toolbox as Value } from "@reactivated";

import {
    StreamField,
    StreamFieldBlockMap,
} from "@thelabnyc/thelabui/src/components/StreamField";

import { ArticleHeroBlock } from "../ArticleHeroBlock";
import { BazaarvoiceEmbed } from "../BazaarvoiceEmbed";
import { BlockGroup } from "../BlockGroup";
import { FeaturesBlock } from "../FeaturesBlock";
import { FloatingPromoBlock } from "../FloatingPromoBlock";
import { FullBleedMediaBlock } from "../FullBleedMediaBlock";
import { HeroCarousel } from "../HeroCarousel";
import { HomePageIntroBlock } from "../HomePageIntro";
import { ReusableContentBlock } from "../ReusableContent";
import { SpacerBlock } from "../SpacerBlock";

export const toolboxComponents: StreamFieldBlockMap<Value> = {
    article_hero: ArticleHeroBlock,
    block_group: BlockGroup,
    features: FeaturesBlock,
    floating_promo: FloatingPromoBlock,
    full_bleed_media: FullBleedMediaBlock,
    homepage_intro: HomePageIntroBlock,
    hero_carousel: HeroCarousel,
    reusable_content: ReusableContentBlock,
    spacer: SpacerBlock,
    customer_reviews: BazaarvoiceEmbed,
};

export const Toolbox = (props: { value: Value }) => {
    return (
        <StreamField
            tagName={React.Fragment}
            components={toolboxComponents}
            value={props.value}
        />
    );
};
